/**
 * The permissions this portal asks about. Mirrors pkg/enums/Permission in the API —
 * what a person may do is a right on the account, never which portal they opened.
 *
 * Only the ones a screen here actually branches on are listed. A button that would
 * always come back 403 is hidden rather than shown and refused.
 */
export enum Permission {
    HousekeepingRead    = 'housekeeping:read',
    HousekeepingWork    = 'housekeeping:work',
    HousekeepingInspect = 'housekeeping:inspect',
    FacilityWork        = 'facility:work',
    MaintenanceRead     = 'maintenance:read',
    MaintenanceReport   = 'maintenance:report',
    MaintenanceWork     = 'maintenance:work',
    PropertyRead        = 'property:read',
    UserRead            = 'user:read',
}
